import { render, staticRenderFns } from "./login_list.vue?vue&type=template&id=27c24fa2&scoped=true&"
import script from "./login_list.vue?vue&type=script&lang=js&"
export * from "./login_list.vue?vue&type=script&lang=js&"
import style0 from "./login_list.vue?vue&type=style&index=0&id=27c24fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c24fa2",
  null
  
)

export default component.exports